import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static get targets() {
    return ['content', 'icon'];
  }

  toggle(event) {
    const button = event.currentTarget;
    const content = button.nextElementSibling;
    const icon = button.querySelector('[data-accordion-target="icon"]');

    const isExpanded = content.classList.contains('expanded');

    // Collapse every panel and mark its trigger collapsed (WCAG 4.1.2).
    this.contentTargets.forEach((element) => {
      element.classList.remove('expanded');
      element.classList.add('collapsed');
      const trigger = element.previousElementSibling;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
    this.iconTargets.forEach((iconElement) => {
      iconElement.classList.remove('rotate-180');
    });

    // Re-open the clicked panel unless it was already open (click = collapse).
    if (!isExpanded) {
      content.classList.remove('collapsed');
      content.classList.add('expanded');
      if (icon) icon.classList.add('rotate-180');
      button.setAttribute('aria-expanded', 'true');
    }
  }
}
